(() => {
  'use strict';

  const root = () => {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  };
  const cartUrl = (path) => `${root().replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
  const moneyCurrency = () => {
    const section = document.querySelector('[data-currency]');
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (section && section.dataset.currency) || 'AUD';
  };
  const formatMoney = (amount) => {
    const value = Number(amount || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: moneyCurrency()
      }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  };

  const ensureStatus = (container, name) => {
    let status = container.querySelector(`[data-${name}-status]`);
    if (!status) {
      status = document.createElement('p');
      status.setAttribute(`data-${name}-status`, '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.className = `${name}-status`;
      container.append(status);
    }
    return status;
  };

  const announce = (container, message, name = 'commerce') => {
    if (container) ensureStatus(container, name).textContent = message;
  };

  const jsonRequest = async (url, options) => {
    const response = await fetch(url, options);
    let data = null;
    try {
      data = await response.json();
    } catch (error) {
      // Shopify can return non-JSON error responses in edge cases.
    }
    if (!response.ok) {
      throw new Error((data && (data.description || data.message)) || 'We could not update your bag. Please try again.');
    }
    return data;
  };

  const drawer = () => document.getElementById('cart-drawer');
  const cartItems = () => document.getElementById('cart-items');
  const cartSubtotal = () => document.getElementById('cart-subtotal');

  const updateCartCount = (count) => {
    const countTargets = document.querySelectorAll('#cart-count, [data-cart-count]');
    countTargets.forEach((target) => {
      target.textContent = String(count || 0);
      target.setAttribute('aria-label', `${count || 0} item${count === 1 ? '' : 's'} in bag`);
    });
  };

  const setDrawerLoading = (isLoading, key) => {
    const element = drawer();
    if (!element) return;
    element.toggleAttribute('aria-busy', Boolean(isLoading));
    if (!key) return;
    element.querySelectorAll('[data-cart-key]').forEach((line) => {
      if (line.dataset.cartKey === String(key)) {
        line.classList.toggle('is-loading', Boolean(isLoading));
        line.querySelectorAll('input, button').forEach((control) => {
          control.disabled = Boolean(isLoading);
        });
      }
    });
  };

  const openDrawer = () => {
    const element = drawer();
    if (!element) return;
    element.hidden = false;
    element.setAttribute('aria-hidden', 'false');
    if (element.tagName === 'DIALOG' && !element.open) {
      try {
        element.showModal();
      } catch (error) {
        element.setAttribute('open', '');
      }
    }
  };

  const closeDrawer = () => {
    const element = drawer();
    if (!element) return;
    if (element.tagName === 'DIALOG' && element.open) element.close();
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
  };

  const productImage = (item) => {
    const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    return image || '';
  };

  const renderDrawerLine = (item) => {
    const line = document.createElement('article');
    line.className = 'cart-line';
    line.dataset.cartKey = item.key;

    const imageLink = document.createElement('a');
    imageLink.className = 'cart-line-media';
    imageLink.href = item.url || '#';
    const imageUrl = productImage(item);
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.product_title || item.title || '';
      image.loading = 'lazy';
      imageLink.append(image);
    }
    line.append(imageLink);

    const info = document.createElement('div');
    info.className = 'cart-line-info';
    const title = document.createElement('a');
    title.className = 'product-name';
    title.href = item.url || '#';
    title.textContent = item.product_title || item.title || 'Item';
    info.append(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variant = document.createElement('p');
      variant.className = 'cart-line-variant';
      variant.textContent = item.variant_title;
      info.append(variant);
    }

    const price = document.createElement('p');
    price.className = 'product-price';
    price.textContent = formatMoney(item.final_line_price == null ? item.line_price : item.final_line_price);
    info.append(price);

    const quantity = document.createElement('div');
    quantity.className = 'quantity-field';
    const quantityLabel = document.createElement('label');
    const inputId = `DrawerQuantity-${item.key.replace(/[^a-zA-Z0-9_-]/g, '')}`;
    quantityLabel.htmlFor = inputId;
    quantityLabel.textContent = 'Quantity';
    const quantityInput = document.createElement('input');
    quantityInput.id = inputId;
    quantityInput.type = 'number';
    quantityInput.min = '0';
    quantityInput.inputMode = 'numeric';
    quantityInput.value = String(item.quantity);
    quantityInput.dataset.cartQuantity = '';
    quantityInput.dataset.cartKey = item.key;
    quantity.append(quantityLabel, quantityInput);
    info.append(quantity);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'button-secondary';
    remove.dataset.cartRemove = '';
    remove.dataset.cartKey = item.key;
    remove.textContent = 'Remove';
    info.append(remove);
    line.append(info);
    return line;
  };

  const renderCartDrawer = (cart) => {
    updateCartCount(cart.item_count);
    const itemsElement = cartItems();
    const subtotalElement = cartSubtotal();
    const element = drawer();
    if (!itemsElement || !element) return;

    itemsElement.replaceChildren();
    if (!cart.item_count) {
      const empty = document.createElement('p');
      empty.className = 'empty-state';
      empty.textContent = 'Your bag is waiting for something soft.';
      itemsElement.append(empty);
    } else {
      cart.items.forEach((item) => itemsElement.append(renderDrawerLine(item)));
    }
    if (subtotalElement) subtotalElement.textContent = formatMoney(cart.total_price);
    announce(element, cart.item_count ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'} in your bag.` : 'Your bag is empty.', 'cart');
  };

  const getCart = () => jsonRequest(cartUrl('cart.js'), { headers: { Accept: 'application/json' } });

  const updateCartLine = async (key, quantity) => {
    const element = drawer();
    if (!element || !key) return;
    const parsedQuantity = Number.parseInt(quantity, 10);
    if (Number.isNaN(parsedQuantity) || parsedQuantity < 0) {
      announce(element, 'Please enter a quantity of zero or more.', 'cart');
      return;
    }
    setDrawerLoading(true, key);
    announce(element, 'Updating your bag…', 'cart');
    try {
      const cart = await jsonRequest(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: parsedQuantity })
      });
      renderCartDrawer(cart);
      announce(element, 'Your bag has been updated.', 'cart');
      setDrawerLoading(false);
    } catch (error) {
      announce(element, error.message || 'We could not update your bag. Please try again.', 'cart');
      setDrawerLoading(false, key);
    }
  };

  const updateProductUI = (form, variant) => {
    const section = form.closest('[data-product-section]') || form.parentElement;
    const available = Boolean(variant && variant.available);
    const price = section && section.querySelector('[data-product-price]');
    const availability = form.querySelector('[data-product-availability]');
    const button = form.querySelector('[data-add-button]');
    const comparePrice = section && section.querySelector('[data-product-compare-price]');
    if (price && variant) price.textContent = formatMoney(variant.price);
    if (comparePrice) {
      if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price);
        comparePrice.hidden = false;
      } else {
        comparePrice.hidden = true;
      }
    }
    if (availability) availability.textContent = available ? 'In stock' : 'Sold out';
    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.textContent = available ? 'Add to bag' : 'Sold out';
    }
    if (variant && variant.featured_media && section) {
      section.querySelectorAll('[data-product-media-id]').forEach((media) => {
        const selected = String(media.dataset.productMediaId) === String(variant.featured_media.id);
        media.toggleAttribute('data-selected-media', selected);
        if (selected) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    }
  };

  const initialiseProductForms = () => {
    document.querySelectorAll('form[data-ajax-product-form]').forEach((form) => {
      const select = form.querySelector('[data-variant-select]');
      const script = form.parentElement && form.parentElement.querySelector('script[data-product-variants]');
      if (!select || !script) return;
      let variants = [];
      try {
        variants = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }
      const renderVariant = () => {
        const selected = variants.find((variant) => String(variant.id) === String(select.value));
        updateProductUI(form, selected);
      };
      select.addEventListener('change', renderVariant);
      renderVariant();
    });
  };

  const addToCart = async (form) => {
    const submit = form.querySelector('button[type="submit"]');
    if (submit && submit.disabled) return;
    const originalLabel = submit ? submit.textContent : '';
    const originallyDisabled = submit ? submit.disabled : false;
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Adding…';
    }
    announce(form, 'Adding to your bag…');
    try {
      await jsonRequest(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams(new FormData(form))
      });
      const cart = await getCart();
      renderCartDrawer(cart);
      announce(form, 'Added to your bag.');
      openDrawer();
    } catch (error) {
      announce(form, error.message || 'We could not add this item to your bag. Please try again.');
    } finally {
      if (submit) {
        submit.disabled = originallyDisabled;
        submit.removeAttribute('aria-busy');
        submit.textContent = originalLabel;
      }
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-ajax-product-form]');
    if (!form || !window.fetch) return;
    const selected = form.querySelector('[name="id"]');
    if (!selected || selected.disabled) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-close-cart]');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    const open = event.target.closest('[data-open-cart]');
    if (open && window.fetch) {
      event.preventDefault();
      openDrawer();
      getCart()
        .then(renderCartDrawer)
        .catch((error) => announce(drawer(), error.message || 'We could not load your bag. Please try again.', 'cart'));
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      updateCartLine(remove.dataset.cartKey, 0);
    }
  });

  document.addEventListener('change', (event) => {
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) updateCartLine(quantity.dataset.cartKey, quantity.value);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initialiseProductForms();
    const element = drawer();
    if (element) {
      element.addEventListener('close', () => {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      });
    }
  });
})();
